import styled from '@emotion/styled';
import COLORS3 from '@zola/zola-ui/src/styles/emotion/colors3';
import MEDIA_QUERY_V2 from '@zola/zola-ui/src/styles/emotion/mediaQueryV2';
import SPACING from '@zola/zola-ui/src/styles/emotion/spacing';

export const Container = styled.section`
  border-bottom: var(--border-grid, 1px solid ${COLORS3.BLACK_030});
  text-align: center;
  padding: ${SPACING.LG} 0 ${SPACING.S24};

  ${MEDIA_QUERY_V2.MOBILE} {
    padding: ${SPACING.S32} 0 ${SPACING.S16};
  }
`;

export const ImageContainer = styled.div`
  display: inline-block;
  padding: ${SPACING.S16};

  ${MEDIA_QUERY_V2.DESKTOP} {
    padding: ${SPACING.S16} ${SPACING.S24};
  }

  ${MEDIA_QUERY_V2.DESKTOP_XL} {
    padding: ${SPACING.S16} ${SPACING.S32};
  }
`;

export const StyledImage = styled.img`
  max-height: 33px;

  ${MEDIA_QUERY_V2.TABLET} {
    max-height: 26px;
  }

  ${MEDIA_QUERY_V2.DESKTOP} {
    max-height: 42px;
  }

  ${MEDIA_QUERY_V2.DESKTOP_XL} {
    max-height: 50px;
  }
`;
